import { Method } from 'axios';

import { endpoints, methods, request } from '../lib/api';

export async function getConfig() {
  const data = await request({ endpoint: endpoints.config, method: methods.GET as Method });

  return data.data.data;
}
